import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { removerAcentos } from '../../../../../../utils'
import {
  faCopy,
  faDownload,
  faEye,
  faInfoCircle,
  faMapLocationDot,
  faMountain,
  faTrash,
  faUpload,
  faWarning,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'
import { HeaderTable } from '../../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../../Components/CustomUi/deleteButton'
import { Empty, Popover, Tag, Tooltip, Upload } from 'antd'
import Carregando from '../../../../../../Components/CustomUi/loading'
import './styles.css'
import { ActionsHeader } from './components/actions'
import { useRef, useState } from 'react'
import {
  getPedLaboratorioStatus,
  OsItensTypes,
  putPedlaboratorioStatus,
} from '../../../../../../services/Laboratorio'
import dayjs from 'dayjs'
import { StatusTimeLine } from './components/statusTimeLine'
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../../../../utils/alert'
import {
  dados_status,
  statusBackground,
  statusBorder,
  statusColor,
  statusIcones,
} from './components/statusTimeLine/meta'
import { Box } from '../../../../../../Components/CustomUi/box'
import { LineDivider } from '../../../../../../Components/CustomUi/LineDivider'
import { SafraItens } from '../../../../../../services/Safra'
import { VisualizarMapaTabela } from './components/visualizarMapaTabela'
import { DownloadReprocessarOS } from './components/download-reprocessar'
import {
  dumpRequest,
  handleDownloadResultado,
  handleReprocessarOs,
  handleUploadResult,
} from '../meta'
import CsvVisualizationModal from './components/visualizarArquivoCSV'
import { VisualizarInconsistencia } from './components/visualizarInconsistencia'
import { InfoAdicionais } from './components/infoAdicionais'
import { Warning } from '../../../../../../Components/CustomUi/warning'
import { ItensPerUserLogged } from '../../../../../../services/login/permissaoUsuarioLoado'

//PROPS
interface Props {
  loading: boolean
  permissions: ItensPerUserLogged
  list_os: OsItensTypes[]
  dataSafraConsultoria: SafraItens[]
  deletar: Function
  abrir: Function
  editar: Function
  copiar: Function
  buscar_tabela: string
  setBuscar_tabela: React.Dispatch<React.SetStateAction<string>>
  setPagination?: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  total: number
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  tab_selecionar_atual: string
  setTab_selecionar_atual: React.Dispatch<React.SetStateAction<string>>
  propriedade_selecionada: string
  setPropriedade_selecionada: React.Dispatch<React.SetStateAction<string>>
  setPropriedade_selecionada_id: React.Dispatch<React.SetStateAction<number>>
  talhao_selecionado: string
  setTalhao_selecionado: React.Dispatch<React.SetStateAction<string>>
  setTalhao_selecionado_id: React.Dispatch<React.SetStateAction<number>>
  tipo_de_analise: number
  listPropriedade: any[]
  listTalhoes: any[]
  refetch: Function
}

export const TabelaOs: React.FC<Props> = ({
  list_os,
  permissions,
  dataSafraConsultoria,
  loading,
  deletar,
  abrir,
  buscar_tabela,
  setBuscar_tabela,
  setPagination,
  editar,
  copiar,
  page,
  setPage,
  total,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  tab_selecionar_atual,
  setTab_selecionar_atual,
  propriedade_selecionada,
  setPropriedade_selecionada,
  setPropriedade_selecionada_id,
  talhao_selecionado,
  setTalhao_selecionado,
  setTalhao_selecionado_id,
  tipo_de_analise,
  listPropriedade,
  listTalhoes,
  refetch,
}) => {
  //STATES
  const refDowloadResult = useRef(null)
  const [numero_pedido, setNumero_pedido] = useState<string>('')
  const [abrirStatus, setAbriuStatus] = useState<boolean>(false)
  const [dataStatusOs, setDataStatusOs] = useState([])
  const [status_selecionada, setStatus_selecionada] = useState<string>('')
  const [status_selecionada_id, setStatus_selecionada_id] = useState<number>(null)
  const [loading_status, setLoading_status] = useState<boolean>(false)
  const [open_popover, setOpen_popover] = useState<number>(null)

  //MAPA GERAL
  const [abrirMapa, setAbrirMapa] = useState<boolean>(false)
  const [cod_mapa, setCod_mapa] = useState<number>(0)

  //TESTE
  const [textCSV, setTextCSV] = useState([])
  const [resultAnalise, setResultAnalise] = useState({
    base64: null,
    cod: null,
  })
  const [abrirPreviewFile, setAbrirPreviewFile] = useState<boolean>(false)

  //INCONSISTENCIA
  const [abrirInconsistencia, setAbrirInconsistencia] = useState<boolean>(false)
  const [textoInconsistencia, setTextoInconsistencia] = useState<string>('')
  const [calcarios, setCalcarios] = useState({ cod_calcario: null, cod_calcario_propriedade: null })

  function buscarOs(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const propriedadeNome = removerAcentos(String(item?.propriedade_nome))
      const laboratorioNome = removerAcentos(String(item?.laboratorio_nome))
      const talhaoNome = removerAcentos(String(item?.talhao_nome))
      return (
        laboratorioNome.toLowerCase().includes(palavraSemAcentos.toLowerCase()) ||
        talhaoNome.toLowerCase().includes(palavraSemAcentos.toLowerCase()) ||
        propriedadeNome.toLowerCase().includes(palavraSemAcentos.toLowerCase()) ||
        !buscar_nome
      )
    }
  }

  async function abrirModal(numero_pedido) {
    setLoading_status(true)
    loadingAlert({ msg: 'Carregando pedidos...', id: 'pedido' })
    const response = await getPedLaboratorioStatus(numero_pedido)

    const dados = response.data.itens

    setDataStatusOs(dados.reverse())
    destroyAlert('pedido')
    setNumero_pedido(numero_pedido)
    setAbriuStatus(true)
    setLoading_status(false)
  }

  function abrirVisualizarMapa(cod) {
    setCod_mapa(cod)
    setAbrirMapa(true)
  }

  const alterarStatus = async () => {
    setLoading_status(true)
    if (status_selecionada_id) {
      const listaStatus = dados_status.find((data) => data.cod === status_selecionada_id)

      const response = await putPedlaboratorioStatus(numero_pedido, listaStatus.cod)

      if (response.status === 200) {
        successAlert(`Status da OS alterado para ${listaStatus.nome}`)
        setLoading_status(false)
        refetch()
        setAbriuStatus(false)
      } else {
        errorAlert(`ERROR ${response.status}`)
        setLoading_status(false)
      }
    } else {
      errorAlert('Selecione o status para ser alterado')
      setLoading_status(false)
    }
  }

  function verificarStatusNome(cod) {
    const filter = dados_status?.filter((item) => item?.cod === cod)

    return filter[0]?.nome === 'ENVIADO PARA ANÁLISE' ? 'ENVIADO' : filter[0]?.nome
  }

  function fecharModal() {
    setNumero_pedido(null)
    setStatus_selecionada('')
    setStatus_selecionada_id(null)
    setAbriuStatus(false)
  }

  console.log('list_os', list_os)

  return (
    <Box style={{ height: 'calc(100vh - 150px)' }} gap={10} borderless>
      {/* <TitleH2>Lista de patrimônios</TitleH2> */}

      <a href='#' hidden ref={refDowloadResult}>
        a
      </a>

      <ActionsHeader
        buscar_tabela={buscar_tabela}
        setBuscar_tabela={setBuscar_tabela}
        tab_selecionar_atual={tab_selecionar_atual}
        setTab_selecionar_atual={setTab_selecionar_atual}
        abrir={abrir}
        propriedade_selecionada={propriedade_selecionada}
        setPropriedade_selecionada={setPropriedade_selecionada}
        setPropriedade_selecionada_id={setPropriedade_selecionada_id}
        talhao_selecionado={talhao_selecionado}
        setTalhao_selecionado={setTalhao_selecionado}
        setTalhao_selecionado_id={setTalhao_selecionado_id}
        listPropriedade={listPropriedade}
        listTalhoes={listTalhoes}
      />

      <StatusTimeLine
        numero_pedido={numero_pedido}
        abrirStatus={abrirStatus}
        setAbrirStatus={setAbriuStatus}
        dataStatusOs={dataStatusOs}
        status_selecionada={status_selecionada}
        setStatus_selecionada={setStatus_selecionada}
        setStatus_selecionada_id={setStatus_selecionada_id}
        alterarStatus={alterarStatus}
        loading_status={loading_status}
        fecharModal={fecharModal}
      />

      <VisualizarMapaTabela open={abrirMapa} update={cod_mapa} setOpen={setAbrirMapa} />

      <CsvVisualizationModal
        isOpen={abrirPreviewFile}
        onClose={() => setAbrirPreviewFile(false)}
        dataCSV={textCSV}
      />
      <VisualizarInconsistencia
        abrir={abrirInconsistencia}
        setAbrir={setAbrirInconsistencia}
        texto={textoInconsistencia}
      />

      <HeaderTable
        itens={[
          { valor: '', width: '40px' },
          { valor: 'Data coleta', width: '120px' },
          { valor: 'Data Liberada', width: '130px' },
          { valor: 'Talhão', width: 'calc(100% - 765px)' },
          { valor: 'Status', width: '130px' },
          { valor: 'Ações', width: '345px' },
        ]}
      />

      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: 'calc(100vh - 170px)',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(list_os ?? [])
            .filter(buscarOs(buscar_tabela))
            .filter((item) => item?.cod_tipo === tipo_de_analise)
            .map(
              (
                {
                  cod,
                  cod_cliente,
                  safra_nome,
                  laboratorio_nome,
                  data_coleta,
                  data_liberada,
                  status,
                  talhao_nome,
                  propriedade_nome,
                  cod_safra_conta,
                  cod_calcario,
                  cod_calcario_propriedade,
                  arquivo_processado_url,
                  resultado_inconsistente,
                  observacao,
                },
                index
              ) => {
                return (
                  <RowTable key={cod} onDoubleClick={() => editar(cod, false)}>
                    <RowItem fontSize={13} width={'40px'}>
                      <Tooltip
                        trigger='hover'
                        placement='right'
                        color='#fff'
                        overlayInnerStyle={{
                          color: '#000',
                          padding: 12,
                          borderRadius: 8,
                          minWidth: resultado_inconsistente === 1 ? '350px' : '220px',
                        }}
                        title={
                          <InfoAdicionais
                            resultado_inconsistente={resultado_inconsistente}
                            dataSafraConsultoria={dataSafraConsultoria}
                            cod_safra_conta={cod_safra_conta}
                            laboratorio_nome={laboratorio_nome}
                            calcarios={calcarios}
                            chamarModalInconsistencia={() => {
                              setAbrirInconsistencia(true)
                              setTextoInconsistencia(observacao)
                              setCalcarios({ cod_calcario, cod_calcario_propriedade })
                            }}
                          />
                        }
                      >
                        <Render condition={resultado_inconsistente === 1}>
                          <div
                            style={{
                              width: '100%',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faWarning}
                              style={{
                                fontSize: 18,
                                color: '#f7e80c',
                                cursor: 'pointer',
                              }}
                            />
                          </div>
                        </Render>
                        <Render condition={resultado_inconsistente === 0}>
                          <div
                            style={{
                              width: '100%',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <FontAwesomeIcon
                              icon={
                                cod_calcario !== cod_calcario_propriedade ? faInfoCircle : faWarning
                              }
                              style={{
                                fontSize: 18,
                                color:
                                  cod_calcario !== cod_calcario_propriedade ? '#2586f5' : '#f08e0d',
                                cursor: 'pointer',
                              }}
                            />
                          </div>
                        </Render>
                      </Tooltip>
                    </RowItem>
                    <RowItem fontSize={13} width={'120px'}>
                      {data_coleta === null ? '' : dayjs(data_coleta).format('DD/MM/YYYY')}
                    </RowItem>
                    <RowItem fontSize={13} width={'130px'}>
                      {data_liberada === null ? '' : dayjs(data_liberada).format('DD/MM/YYYY')}
                    </RowItem>
                    <RowItem fontSize={13} width={'calc(100% - 760px)'}>
                      {talhao_nome}
                    </RowItem>
                    <RowItem fontSize={13} width={'130px'}>
                      <Tag
                        className='tag_os'
                        color={statusBackground[status]}
                        style={{
                          color: statusColor[status],
                          border: `1px solid ${statusBorder[status]}`,
                        }}
                        onClick={() => abrirModal(cod)}
                      >
                        <FontAwesomeIcon icon={statusIcones[status]} />
                        {verificarStatusNome(status)}
                      </Tag>
                    </RowItem>
                    <RowItem width={'340px'} gap={10}>
                      <DeleteButton
                        open={confirmar_exclusao && id_item_atual === cod}
                        trigger={setConfirmar_exclusao}
                        onTrigger={() => {
                          setId_item_atual(cod)
                          setNome_item_atual(propriedade_nome)
                        }}
                        loading={fake_loading}
                        message={
                          <div
                            style={{
                              width: '323px',
                              display: 'flex',
                              padding: '8px',
                              backgroundColor: '#FFF0D9',
                            }}
                          >
                            <h3 style={{ padding: '0px', margin: '0px', color: '#DF8600', lineHeight: '1.3', fontSize: '13px' }}>
                              {' '}
                              Atenção: Ao deletar essa OS comprometerá a sincronização no app caso
                              esteja ocorrendo a execução no campo.
                            </h3>
                          </div>
                        }
                        deleteds={[propriedade_nome]}
                        onDelete={() => {
                          deletar(cod, propriedade_nome)
                        }}
                        disabled={fake_loading || permissions?.exclusao === 0}
                        typeButtonTrigger='tertiary'
                      />

                      <ButtonCustom
                        icon={<FontAwesomeIcon icon={faMapLocationDot} />}
                        type='secondary'
                        onClick={() => {
                          abrirVisualizarMapa(cod)
                        }}
                        disabled={permissions?.acesso === 0 && permissions?.alteracao === 0}
                      />

                      <ButtonCustom
                        icon={<FontAwesomeIcon icon={faCopy} />}
                        type='secondary'
                        onClick={() => {
                          copiar(cod)
                        }}
                        hidden={permissions?.inclusao === 0}
                      />
                      <Render condition={status === 9}>
                        <Popover
                          open={open_popover === cod}
                          onOpenChange={(open) => setOpen_popover(open ? cod : null)}
                          content={() => (
                            <DownloadReprocessarOS
                              handleDownloadResultado={() =>
                                handleDownloadResultado(arquivo_processado_url, refDowloadResult)
                              }
                              handleReprocessarOs={() =>
                                handleReprocessarOs(
                                  cod,
                                  cod_cliente,
                                  propriedade_nome,
                                  talhao_nome,
                                  cod_calcario,
                                  cod_calcario_propriedade
                                )
                              }
                            />
                          )}
                        >
                          <ButtonCustom
                            icon={<FontAwesomeIcon icon={faDownload} />}
                            type='secondary'
                            onClick={() => {
                              setOpen_popover(cod)
                            }}
                          />
                        </Popover>
                      </Render>
                      <Render condition={status === 3 || status === 8}>
                        <Upload
                          accept='.csv'
                          onChange={(file) =>
                            handleUploadResult(
                              file,
                              cod,
                              setResultAnalise,
                              setTextCSV,
                              setAbrirPreviewFile
                            )
                          }
                          customRequest={dumpRequest}
                          showUploadList={false}
                        >
                          <ButtonCustom
                            type='secondary'
                            onClick={undefined}
                            icon={<FontAwesomeIcon icon={faUpload} />}
                            disabled={permissions?.alteracao === 0}
                          />
                        </Upload>
                      </Render>

                      <ButtonCustom
                        icon={<FontAwesomeIcon icon={faEye} />}
                        onClick={() => {
                          editar(cod)
                        }}
                        disabled={permissions?.acesso === 0 && permissions?.alteracao === 0}
                      >
                        Ver / Editar
                      </ButtonCustom>
                    </RowItem>
                  </RowTable>
                )
              }
            )}
        </Render>

        <Render condition={list_os?.length === 0 && !loading}>
          {buscar_tabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Selecione uma propriedade para visualizar as OS!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscar_tabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando OS...'
            justifyContent='center'
            height={400}
            size='default'
          />
        </Render>
      </BodyTable>
    </Box>
  )
}
